import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CLICKABLE_TITLE_CONSTANTS } from '../constants';

/**
 * Container for the clickable title
 * Handles flex layout, gap spacing, and hover effects
 */
export const ClickableTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  gap: theme.spacing(CLICKABLE_TITLE_CONSTANTS.MOBILE_GAP),

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(CLICKABLE_TITLE_CONSTANTS.TABLET_GAP),
  },

  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(CLICKABLE_TITLE_CONSTANTS.DESKTOP_GAP),
  },

  '&:hover': {
    opacity: 0.8,
  },
}));

/**
 * Title text with responsive font sizing
 */
export const ClickableTitleText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.main,
  fontSize: theme.typography.pxToRem(
    CLICKABLE_TITLE_CONSTANTS.MOBILE_FONT_SIZE,
  ),

  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(
      CLICKABLE_TITLE_CONSTANTS.DESKTOP_FONT_SIZE,
    ),
  },
}));

/**
 * Caret wrapper with rotation animation
 * Handles transform, transition, and responsive scaling
 */
interface CaretWrapperProps {
  isOpen: boolean;
}

export const CaretWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})<CaretWrapperProps>(({ theme, isOpen }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  transformOrigin: 'center',
  transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
  transition: theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.short,
    easing: theme.transitions.easing.easeInOut,
  }),

  '& svg': {
    transform: `scale(${CLICKABLE_TITLE_CONSTANTS.CARET_MOBILE_SCALE})`,

    [theme.breakpoints.up('sm')]: {
      transform: `scale(${CLICKABLE_TITLE_CONSTANTS.CARET_DESKTOP_SCALE})`,
    },
  },
}));
